import $ from 'jquery';

// Features
import '../../features/videos/template-parts/video-gallery/video-gallery.js'; import '../../features/videos/videos.js';

// Partials
import '../../partials/component/component-menu-toggle/component-menu-toggle.js'; import '../../partials/site/site-footer/site-footer.js';
import scrollTopAnimated from '../../partials/site/site-footer/site-footer.js';
$(function () {
  s;
});
$('#scrollTop').on("click", function () {
  scrollTopAnimated();
});
var $forms = $('.wpcf7-form, .AlistSubscribeForm');
var $inputs = $('.wpcf7-form-control, .AlistSubscribeForm-input');
var fieldWrapper = '.field-wrapper';

// set data-focussed based on focus/blur state
$inputs.on('focus blur', function (e) {
  $(this).closest(fieldWrapper).attr('data-focused', e.type == 'focus');
});
$inputs.on('blur', function (e) {
  var $input = $(this);
  var hasValue = $input.val() != undefined && $input.val() != '';
  $input.closest(fieldWrapper).attr('data-has-value', hasValue);
});
$forms.on('reset', function (e) {
  var $form = $(e.currentTarget);
  $form.find(':focus').trigger('blur');
  $form.find('[data-has-value="true"]').attr('data-has-value', false);
});